import m from "../../geodata/es2015/pakistanHigh";
window.am4geodata_pakistanHigh = m;


//////////////////
// WEBPACK FOOTER
// ./geodata/pakistanHigh.js
// module id = null
// module chunks = 